export interface RuntimeConfig {
  apiUrl: string;
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  storageKey: string;
  passwordMinLength: number;
}

const defaults: RuntimeConfig = {
  apiUrl: '',
  region: 'us-east-1',
  userPoolId: '',
  userPoolClientId: '',
  storageKey: 'sense.admin.session',
  passwordMinLength: 12,
};

let cached: RuntimeConfig | null = null;

export async function loadConfig(): Promise<RuntimeConfig> {
  if (cached) return cached;
  try {
    const resp = await fetch('/config.json', { cache: 'no-store' });
    if (resp.ok) {
      const data = (await resp.json()) as Partial<RuntimeConfig>;
      cached = { ...defaults, ...data, passwordMinLength: data.passwordMinLength ?? 12 };
      // Local Vite uses /api proxy to avoid CORS until admin-api OPTIONS are deployed.
      if (
        typeof window !== 'undefined' &&
        (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') &&
        cached.apiUrl.startsWith('http')
      ) {
        cached = { ...cached, apiUrl: '/api' };
      }
      return cached;
    }
  } catch {
    // fall through
  }
  cached = defaults;
  return cached;
}

export const config: RuntimeConfig = defaults;

export async function ensureConfig(): Promise<RuntimeConfig> {
  const loaded = await loadConfig();
  Object.assign(config, loaded);
  return config;
}
